import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { PlaybooksLayout } from './components/PlaybooksLayout';
import { PlaybooksHome } from './components/PlaybooksHome';
import { PlaybooksConfigPage } from './components/PlaybooksConfigPage';
import { PlaybooksSettingsPage } from './components/PlaybooksSettingsPage';
import { PlayFlowShell } from './components/play-flow/PlayFlowShell';
import { flowContextFromRoute, flowContextKey } from './play-flow-context';

// Keys on playId so React fully remounts (resets all state) when navigating
// between different Plays — same idiom as Win Tool's `DetailPageKeyed`.
// `PlayFlowShell` is the qualify/sequences/review shell with the persistent
// members table.
//
// terra-qyt.14 (U9) — builds the `FlowContext` this route's doorway maps to
// (`play-flow-context.ts`) and keys on `flowContextKey`, not the raw
// `playId`, so the reset-on-identity-change behavior stays correct if a
// future doorway ever shared an id namespace with another kind.
function PlayFlowShellKeyed() {
  const { playId } = useParams();
  const context = flowContextFromRoute({ playId });
  return <PlayFlowShell key={flowContextKey(context)} context={context} />;
}

// terra-qyt.14 (U9) — the playbook-only-authoring doorway to the SAME shell:
// no Play, no required campaign — `PlayFlowShell` mounts every step directly
// off the Playbook's own id (see that component's own doc for how it
// narrows `context.kind`).
function PlaybookFlowShellKeyed() {
  const { playbookId } = useParams();
  const context = flowContextFromRoute({ playbookId });
  return <PlayFlowShell key={flowContextKey(context)} context={context} />;
}

// Playbooks — formerly "Launcher V2", extracted from mini-apps/launcher into
// its own app. Dark mode is host-owned (MiniAppLayout's useMiniAppDarkMode).
// All pages render inside PlaybooksLayout, which owns the toast region mount
// and nav.
export default function PlaybooksApp() {
  return (
    <Routes>
      <Route element={<PlaybooksLayout />}>
        <Route index element={<PlaybooksHome />} />
        <Route path="config" element={<PlaybooksConfigPage />} />
        <Route path="settings" element={<PlaybooksSettingsPage />} />
        <Route path="play/:playId" element={<PlayFlowShellKeyed />} />
        <Route path="playbook/:playbookId" element={<PlaybookFlowShellKeyed />} />
      </Route>
    </Routes>
  );
}
